<div class="card card-outline card-primary">
  <div class="card-header text-center">
    <a [routerLink]="['/']" class="h1">
      <b>Admin</b>
      LTE
    </a>
  </div>
  <div class="card-body">
    <p class="login-box-msg">Register a new membership</p>

    <form (ngSubmit)="registerByAuth()" [formGroup]="registerForm">
      <div class="input-group mb-3">
        <input class="form-control" formControlName="email" placeholder="Email" type="email" />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-envelope"></span>
          </div>
        </div>
      </div>
      <div class="input-group mb-3">
        <input
          class="form-control"
          formControlName="password"
          placeholder="Password"
          type="password"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-lock"></span>
          </div>
        </div>
      </div>
      <div class="input-group mb-3">
        <input
          class="form-control"
          formControlName="retypePassword"
          placeholder="Retype password"
          type="password"
        />
        <div class="input-group-append">
          <div class="input-group-text">
            <span class="fas fa-lock"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="icheck-primary">
            <input id="agreeTerms" name="terms" type="checkbox" value="agree" />
            <label for="agreeTerms">
              I agree to the
              <a href="#">terms</a>
            </label>
          </div>
        </div>
        <!-- /.col -->
        <div class="col-5">
          <app-button [additionalClass]="'btn-block'" [loading]="isAuthLoading" [type]="'submit'">
            Register
          </app-button>
        </div>
        <!-- /.col -->
      </div>
    </form>
    <a [routerLink]="['/login']" class="text-center">I already have a membership</a>
  </div>
</div>
